import { connect } from 'react-redux'
import { FormattedHTMLMessage } from 'react-intl'
import { isMobileSelector } from '../../selectors/device'
import { Link } from 'spa/components/link'
import { linkifyArtistNames, makeSongUrl } from 'spa/urls'
import { PlayTrackButton } from 'spa/components/track_buttons/play_track_button'
import { SongPropType } from 'spa/api/songs'
import { SongVersionsPopover } from 'spa/components/table/song_versions_popover'
import { TableSeparator } from '../table/table_separator'
import { TextStyle } from 'spa/components/typography'
import { ToolTip } from '../tooltip'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import styles from './styles'

class SongsListItem extends React.PureComponent {
  static propTypes = {
    addSongToQueue: PropTypes.func,
    blur: PropTypes.bool,
    currentlyInQueue: PropTypes.bool,
    fixedPopover: PropTypes.bool,
    index: PropTypes.number,
    isMobile: PropTypes.bool,
    listIndex: PropTypes.number,
    removeSongFromQueue: PropTypes.func,
    showArtist: PropTypes.bool,
    showBorder: PropTypes.bool,
    showPopularity: PropTypes.bool,
    song: SongPropType,
    trackList: PropTypes.string,
    variant: PropTypes.oneOf(['light', 'dark']),
  }

  constructor(props) {
    super(props)
    this.state = {
      open1: false,
      open2: false,
    }
  }

  render() {
    const {
      blur,
      index,
      listIndex,
      showBorder,
      song,
      currentlyInQueue,
      removeSongFromQueue,
      variant = 'dark',
      addSongToQueue,
      trackList,
      showArtist = true,
      fixedPopover = false,
      showPopularity = false,
      isMobile,
    } = this.props
    return (
      <div>
        <li
          className={classNames(styles.listItem, {
            [styles.listItemWithBorder]: showBorder,
            [styles.bluredItem]: blur,
            [styles.tableRowContainerOpen]:
              this.state.open1 || this.state.open2,
          })}
          key={song.rid}
        >
          <PlayTrackButton
            listIndex={listIndex}
            numberIndex={index}
            songId={song.rid}
            trackList={trackList}
          />
          <div className={classNames(styles.info)}>
            <Link to={makeSongUrl(song)}>
              <TextStyle
                className={styles.cellTitle}
                color={variant === 'dark' ? 'black' : 'white'}
                truncate
                variant="bold"
              >
                {song.title}
              </TextStyle>
            </Link>
            {showArtist && (
              <TextStyle
                className={classNames('artist-names', styles.artist)}
                color={variant === 'dark' ? 'grey' : 'white'}
                tagName="p"
                truncate
              >
                {linkifyArtistNames(song)}
              </TextStyle>
            )}
            {showPopularity && (
              <div className={styles.popularityContainer}>
                <ToolTip
                  toolTipContent={
                    <FormattedHTMLMessage
                      defaultMessage="Versions"
                      id="djcity.common.popularity.label"
                    />
                  }
                >
                  <div className={styles.popularityProgress}>
                    <div
                      className={styles.progress}
                      style={{ width: `${song.popularity}%` }}
                    />
                  </div>
                </ToolTip>
              </div>
            )}
          </div>
          {!isMobile && (
            <div className={styles.moreBlock}>
              <SongVersionsPopover
                buttonIcon="arrow-alt-circle-down"
                currentlyInQueue={currentlyInQueue}
                fixed={fixedPopover}
                onAddSongToQueue={addSongToQueue}
                onRemoveSongFromQueue={removeSongFromQueue}
                setIsOpen={open => this.setState({ open1: open })}
                songId={song.rid}
                trackList={trackList}
              />
            </div>
          )}
          <div className={styles.moreBlock}>
            <SongVersionsPopover
              buttonIcon="ellipsis-h"
              currentlyInQueue={currentlyInQueue}
              fixed={fixedPopover}
              onAddSongToQueue={addSongToQueue}
              onRemoveSongFromQueue={removeSongFromQueue}
              setIsOpen={open => this.setState({ open2: open })}
              songId={song.rid}
              trackList={trackList}
            />
          </div>
        </li>
        <TableSeparator />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    isMobile: isMobileSelector(state),
  }
}

const ConnectedSongsListItem = connect(mapStateToProps)(SongsListItem)

export { ConnectedSongsListItem as SongsListItem }
